import { Link } from "react-router-dom";
import { usePageMeta, useSite } from "@/lib/store";
import { WRAP } from "@/components/store/Chrome";

const img = (u) => (u?.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${u}` : u);
const paras = (t, cls = "") => (t || "").split(/\n{2,}/).filter(Boolean).map((p, i) => <p key={i} className={cls}>{p}</p>);

function Person({ p, i }) {
  return (
    <article className="grid gap-6 content-start" data-testid={`about-person-${i}`}>
      <div className="aspect-[4/5] bg-[#eee] overflow-hidden border border-[#e3e3e3]">
        {p.image && <img src={img(p.image)} alt={`${p.name}, co-founder of Vinyl Record Vault`} className="w-full h-full object-cover" loading="lazy" data-testid={`about-person-img-${i}`} />}
      </div>
      <div>
        <h3 className="font-head font-extrabold text-2xl tracking-tight">{p.name}</h3>
        <p className="mt-3 text-[#444] leading-relaxed">{p.text}</p>
      </div>
    </article>
  );
}

export default function About() {
  const { site } = useSite();
  const a = site?.about;
  usePageMeta("About Us | Vinyl Record Vault", "Meet Dhruv & Vedant, the two brothers behind Vinyl Record Vault – an online record store with a catalogue of new vinyl titles.");
  if (!a) return <div className={`${WRAP} h-96`} />;
  return (
    <div className={`${WRAP} pt-12 pb-8`} data-testid="about-page">
      <p className="label-caps text-[11px] text-red mb-3">About us</p>
      <h1 className="font-head font-extrabold text-3xl sm:text-5xl tracking-tight leading-[1.05] max-w-4xl" data-testid="about-quote">{a.quote}</h1>
      <div className="mt-10 max-w-3xl space-y-5 text-[17px] leading-relaxed text-[#333]" data-testid="about-intro">{paras(a.intro)}</div>

      <ul className="mt-14 grid sm:grid-cols-3 border-y-2 border-black divide-y sm:divide-y-0 sm:divide-x divide-[#ddd]" data-testid="about-stats">
        {(a.stats || []).map((s, i) => (
          <li key={i} className="py-7 sm:px-7 first:sm:pl-0">
            <p className="font-head font-extrabold text-3xl text-red tracking-tight">{s.value}</p>
            <p className="label-caps text-[11px] text-[#666] mt-1.5">{s.label}</p>
          </li>
        ))}
      </ul>

      <section className="mt-20">
        <p className="label-caps text-[11px] text-red">{a.team_label}</p>
        <h2 className="font-head font-extrabold text-3xl sm:text-4xl tracking-tight mt-2">{a.team_heading}</h2>
        <p className="mt-4 max-w-3xl text-[#444] leading-relaxed">{a.team_intro}</p>
        <div className="mt-10 grid sm:grid-cols-2 gap-10 lg:gap-16">{(a.people || []).map((p, i) => <Person key={i} p={p} i={i} />)}</div>
      </section>

      <section className="mt-20 bg-black text-white px-6 sm:px-12 py-14">
        <p className="label-caps text-[11px] text-[#ff6b72]">{a.why_label}</p>
        <h2 className="font-head font-extrabold text-3xl sm:text-4xl tracking-tight mt-2 max-w-3xl">{a.why_heading}</h2>
        <div className="mt-8 max-w-3xl space-y-5 text-[16px] leading-relaxed text-[#d8d8d8]" data-testid="about-why">{paras(a.why_body)}</div>
      </section>

      <section className="mt-16 flex flex-wrap items-center justify-between gap-6 border-2 border-black px-6 sm:px-10 py-10">
        <h2 className="font-head font-extrabold text-2xl sm:text-3xl tracking-tight">{a.cta_heading}</h2>
        <Link to="/shop" className="h-12 px-8 inline-flex items-center bg-red text-white text-xs font-bold tracking-[0.15em] uppercase hover:bg-black transition-colors" data-testid="about-cta">{a.cta_button}</Link>
      </section>
    </div>
  );
}
